/**
 * Mobil randevu akışı API servisleri (mobile.md'ye göre)
 */
import { safeApiRequest, getApiBaseUrl, getStoredToken } from './apiClient';
import { getCsrfToken } from './authService';

/**
 * İşlem ve parça listesi (dropdown için)
 * GET /api/mobile/service-contents
 */
export const fetchMobileServiceContents = async (servisKaydiId = null) => {
  let url = '/api/mobile/service-contents';
  if (servisKaydiId) {
    url += `?servisKaydiId=${encodeURIComponent(servisKaydiId)}`;
  }
  return safeApiRequest(url, {
    method: 'GET',
    skipCsrf: true,
  });
};

/**
 * OTP oluştur
 * POST /api/mobile/appointments/{randevuId}/generate-otp
 */
export const generateOtp = async (randevuId) => {
  if (!randevuId) throw new Error('Randevu ID gereklidir');
  return safeApiRequest(`/api/mobile/appointments/${randevuId}/generate-otp`, {
    method: 'POST',
    body: {},
    skipCsrf: false,
  });
};

/**
 * OTP doğrula ve randevu bilgilerini kaydet (FormData)
 * POST /api/mobile/appointments/{randevuId}/verify-otp
 */
export const verifyOtp = async (randevuId, formData) => {
  if (!randevuId) throw new Error('Randevu ID gereklidir');
  const token = getStoredToken();
  const csrfToken = await getCsrfToken();

  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (csrfToken) headers['X-CSRF-Token'] = csrfToken;
  // FormData kullanıldığında Content-Type eklenmez (browser otomatik boundary ekler)

  const apiBase = getApiBaseUrl().replace(/\/$/, '');
  const response = await fetch(`${apiBase}/api/mobile/appointments/${randevuId}/verify-otp`, {
    method: 'POST',
    headers,
    body: formData,
    credentials: 'include',
  });

  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(json?.mesaj || json?.message || 'OTP doğrulama başarısız');
    err.status = response.status;
    err.data = json;
    throw err;
  }
  return json;
};

/**
 * OTP opsiyonel tamamlama (ödeme alınamadı senaryosu)
 * POST /api/mobile/appointments/{randevuId}/complete-deferred
 */
export const completeDeferred = async (randevuId, formData) => {
  if (!randevuId) throw new Error('Randevu ID gereklidir');
  const token = getStoredToken();
  const csrfToken = await getCsrfToken();

  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (csrfToken) headers['X-CSRF-Token'] = csrfToken;

  const apiBase = getApiBaseUrl().replace(/\/$/, '');
  const response = await fetch(`${apiBase}/api/mobile/appointments/${randevuId}/complete-deferred`, {
    method: 'POST',
    headers,
    body: formData,
    credentials: 'include',
  });

  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(json?.mesaj || json?.message || 'Tamamlama başarısız');
    err.status = response.status;
    err.data = json;
    throw err;
  }
  return json;
};
